import { render, staticRenderFns } from "./AccountsDashboard.vue?vue&type=template&id=1d562106"
import script from "./AccountsDashboard.vue?vue&type=script&lang=js"
export * from "./AccountsDashboard.vue?vue&type=script&lang=js"
import style0 from "./AccountsDashboard.vue?vue&type=style&index=0&id=1d562106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports